'use client';
import React from 'react';
import classNames from 'classnames';
import { Table, type ColumnDef } from '@benzinga/table';
import { EdgeGateCTAOverlay, useEdgeRowsGate } from './EdgeRowsGate';

interface QuoteListTableProps<T> {
  className?: string;
  columnsDef: ColumnDef<T>[];
  gateType?: string;
  noDataText?: string;
  rowData: T[];
  sortEnabled?: boolean;
  visibleRows?: number;
}

export const QuoteListTable = <T,>({
  className,
  columnsDef,
  gateType,
  noDataText,
  rowData,
  sortEnabled = false,
  visibleRows = 2,
}: QuoteListTableProps<T>) => {
  const rows = rowData ?? [];
  const { isGated, visibleRowCount } = useEdgeRowsGate(rows.length, visibleRows);
  const hasOverlay = Boolean(gateType && isGated && rows.length > visibleRowCount);

  if (!rows.length) {
    return noDataText ? <p className="text-sm text-gray-400">{noDataText}</p> : null;
  }

  return (
    <div className="relative">
      <Table
        autoHeight
        className={classNames('quote-table', className)}
        columnsDef={columnsDef}
        fitContent
        gatedRowBlur="row"
        gatedVisibleRowCount={visibleRowCount}
        isGated={gateType ? isGated : undefined}
        noDataText={noDataText}
        rowData={rows}
        sortEnabled={sortEnabled}
        tableClassName="min-w-max"
      />
      {hasOverlay && gateType && <EdgeGateCTAOverlay type={gateType} />}
    </div>
  );
};

export default QuoteListTable;
